import { configureStore, combineReducers } from "@reduxjs/toolkit";
import apiConfigurationState from "./apiConfigurationState";
import ganttChartSlice from "./ganttChart/index";
import dragAndDropSlice from "./dragAndDrop/index";
import drawerSlice from "./drawer/index";
import timelineSlice from "./timeline/index";
import nexusFiltersSlice from "./nexusFilters";
import kpiCollectionSlice from "./KPICollection";
import searchSlice from "./search";
import toastNotifications from "./toastNotifications";
import realTimeUpdateSlice from "./realTimeUpdates";
import calendarSettingsSlice from "./calendarSettings/index";
import overlaySlice from "./overlay";
import employeeSettingsSlice from "./employeeSettings";
import pondooStatusBarSlice from "./pondooStatusBar";

const store = configureStore({
  reducer: combineReducers({
    apiConfigurationState,
    ganttChartSlice,
    dragAndDropSlice,
    drawerSlice,
    timelineSlice,
    nexusFiltersSlice,
    kpiCollectionSlice,
    searchSlice,
    toastNotifications,
    realTimeUpdateSlice,
    calendarSettingsSlice,
    overlaySlice,
    employeeSettingsSlice,
    pondooStatusBarSlice,
  }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
